"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseUsersApi = exports.PromiseUsageAndBillingApi = exports.PromiseTrailsApi = exports.PromiseSettingsApi = exports.PromiseRolesApi = exports.PromiseResourcesApi = exports.PromiseRecordsApi = exports.PromisePermissionsApi = exports.PromiseOrganizationsApi = exports.PromiseInvitesApi = exports.PromiseActorsApi = exports.PromiseAPIKeysApi = exports.PromiseAPIClientsApi = void 0;
var ObservableAPI_1 = require("./ObservableAPI");
var PromiseAPIClientsApi = (function () {
    function PromiseAPIClientsApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_1.ObservableAPIClientsApi(configuration, requestFactory, responseProcessor);
    }
    PromiseAPIClientsApi.prototype.createApiClient = function (organizationId, aPIClientMutation, _options) {
        var result = this.api.createApiClient(organizationId, aPIClientMutation, _options);
        return result.toPromise();
    };
    PromiseAPIClientsApi.prototype.deleteApiClient = function (organizationId, apiClientId, _options) {
        var result = this.api.deleteApiClient(organizationId, apiClientId, _options);
        return result.toPromise();
    };
    PromiseAPIClientsApi.prototype.getApiClient = function (organizationId, apiClientId, _options) {
        var result = this.api.getApiClient(organizationId, apiClientId, _options);
        return result.toPromise();
    };
    PromiseAPIClientsApi.prototype.listApiClients = function (organizationId, _options) {
        var result = this.api.listApiClients(organizationId, _options);
        return result.toPromise();
    };
    PromiseAPIClientsApi.prototype.listRolesForApiClient = function (organizationId, apiClientId, _options) {
        var result = this.api.listRolesForApiClient(organizationId, apiClientId, _options);
        return result.toPromise();
    };
    PromiseAPIClientsApi.prototype.updateApiClient = function (organizationId, apiClientId, aPIClientMutation, _options) {
        var result = this.api.updateApiClient(organizationId, apiClientId, aPIClientMutation, _options);
        return result.toPromise();
    };
    return PromiseAPIClientsApi;
}());
exports.PromiseAPIClientsApi = PromiseAPIClientsApi;
var ObservableAPI_2 = require("./ObservableAPI");
var PromiseAPIKeysApi = (function () {
    function PromiseAPIKeysApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_2.ObservableAPIKeysApi(configuration, requestFactory, responseProcessor);
    }
    PromiseAPIKeysApi.prototype.createApiKey = function (organizationId, apiClientId, aPIKeyMutation, _options) {
        var result = this.api.createApiKey(organizationId, apiClientId, aPIKeyMutation, _options);
        return result.toPromise();
    };
    PromiseAPIKeysApi.prototype.deleteApiKey = function (organizationId, apiClientId, apiKeyId, _options) {
        var result = this.api.deleteApiKey(organizationId, apiClientId, apiKeyId, _options);
        return result.toPromise();
    };
    PromiseAPIKeysApi.prototype.listApiKeysForApiClient = function (organizationId, apiClientId, _options) {
        var result = this.api.listApiKeysForApiClient(organizationId, apiClientId, _options);
        return result.toPromise();
    };
    PromiseAPIKeysApi.prototype.updateApiKey = function (organizationId, apiClientId, apiKeyId, aPIKeyMutation, _options) {
        var result = this.api.updateApiKey(organizationId, apiClientId, apiKeyId, aPIKeyMutation, _options);
        return result.toPromise();
    };
    return PromiseAPIKeysApi;
}());
exports.PromiseAPIKeysApi = PromiseAPIKeysApi;
var ObservableAPI_3 = require("./ObservableAPI");
var PromiseActorsApi = (function () {
    function PromiseActorsApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_3.ObservableActorsApi(configuration, requestFactory, responseProcessor);
    }
    PromiseActorsApi.prototype.getActor = function (organizationId, actorId, _options) {
        var result = this.api.getActor(organizationId, actorId, _options);
        return result.toPromise();
    };
    PromiseActorsApi.prototype.listActors = function (organizationId, beforeDate, limit, _options) {
        var result = this.api.listActors(organizationId, beforeDate, limit, _options);
        return result.toPromise();
    };
    return PromiseActorsApi;
}());
exports.PromiseActorsApi = PromiseActorsApi;
var ObservableAPI_4 = require("./ObservableAPI");
var PromiseInvitesApi = (function () {
    function PromiseInvitesApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_4.ObservableInvitesApi(configuration, requestFactory, responseProcessor);
    }
    PromiseInvitesApi.prototype.acceptInvite = function (acceptInviteMutation, _options) {
        var result = this.api.acceptInvite(acceptInviteMutation, _options);
        return result.toPromise();
    };
    PromiseInvitesApi.prototype.createInvite = function (organizationId, inviteMutation, _options) {
        var result = this.api.createInvite(organizationId, inviteMutation, _options);
        return result.toPromise();
    };
    PromiseInvitesApi.prototype.deleteInvite = function (organizationId, inviteId, _options) {
        var result = this.api.deleteInvite(organizationId, inviteId, _options);
        return result.toPromise();
    };
    PromiseInvitesApi.prototype.listInvites = function (organizationId, _options) {
        var result = this.api.listInvites(organizationId, _options);
        return result.toPromise();
    };
    return PromiseInvitesApi;
}());
exports.PromiseInvitesApi = PromiseInvitesApi;
var ObservableAPI_5 = require("./ObservableAPI");
var PromiseOrganizationsApi = (function () {
    function PromiseOrganizationsApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_5.ObservableOrganizationsApi(configuration, requestFactory, responseProcessor);
    }
    PromiseOrganizationsApi.prototype.createOrganization = function (organizationMutation, _options) {
        var result = this.api.createOrganization(organizationMutation, _options);
        return result.toPromise();
    };
    PromiseOrganizationsApi.prototype.deleteOrganization = function (organizationId, _options) {
        var result = this.api.deleteOrganization(organizationId, _options);
        return result.toPromise();
    };
    PromiseOrganizationsApi.prototype.listOrganizations = function (_options) {
        var result = this.api.listOrganizations(_options);
        return result.toPromise();
    };
    return PromiseOrganizationsApi;
}());
exports.PromiseOrganizationsApi = PromiseOrganizationsApi;
var ObservableAPI_6 = require("./ObservableAPI");
var PromisePermissionsApi = (function () {
    function PromisePermissionsApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_6.ObservablePermissionsApi(configuration, requestFactory, responseProcessor);
    }
    PromisePermissionsApi.prototype.addPermissions = function (organizationId, roleId, permissionMutation, _options) {
        var result = this.api.addPermissions(organizationId, roleId, permissionMutation, _options);
        return result.toPromise();
    };
    PromisePermissionsApi.prototype.removePermissions = function (organizationId, roleId, permissionDeletion, _options) {
        var result = this.api.removePermissions(organizationId, roleId, permissionDeletion, _options);
        return result.toPromise();
    };
    return PromisePermissionsApi;
}());
exports.PromisePermissionsApi = PromisePermissionsApi;
var ObservableAPI_7 = require("./ObservableAPI");
var PromiseRecordsApi = (function () {
    function PromiseRecordsApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_7.ObservableRecordsApi(configuration, requestFactory, responseProcessor);
    }
    PromiseRecordsApi.prototype.createRecord = function (organizationId, trailId, recordMutation, _options) {
        var result = this.api.createRecord(organizationId, trailId, recordMutation, _options);
        return result.toPromise();
    };
    PromiseRecordsApi.prototype.listActorRecords = function (organizationId, actorId, beforeDate, limit, _options) {
        var result = this.api.listActorRecords(organizationId, actorId, beforeDate, limit, _options);
        return result.toPromise();
    };
    PromiseRecordsApi.prototype.listRecords = function (organizationId, beforeDate, limit, _options) {
        var result = this.api.listRecords(organizationId, beforeDate, limit, _options);
        return result.toPromise();
    };
    PromiseRecordsApi.prototype.listResourceRecords = function (organizationId, resourceId, beforeDate, limit, _options) {
        var result = this.api.listResourceRecords(organizationId, resourceId, beforeDate, limit, _options);
        return result.toPromise();
    };
    PromiseRecordsApi.prototype.listTrailRecords = function (organizationId, trailId, beforeDate, limit, _options) {
        var result = this.api.listTrailRecords(organizationId, trailId, beforeDate, limit, _options);
        return result.toPromise();
    };
    PromiseRecordsApi.prototype.reindexTrailRecord = function (organizationId, trailId, recordId, _options) {
        var result = this.api.reindexTrailRecord(organizationId, trailId, recordId, _options);
        return result.toPromise();
    };
    return PromiseRecordsApi;
}());
exports.PromiseRecordsApi = PromiseRecordsApi;
var ObservableAPI_8 = require("./ObservableAPI");
var PromiseResourcesApi = (function () {
    function PromiseResourcesApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_8.ObservableResourcesApi(configuration, requestFactory, responseProcessor);
    }
    PromiseResourcesApi.prototype.getResource = function (organizationId, resourceId, _options) {
        var result = this.api.getResource(organizationId, resourceId, _options);
        return result.toPromise();
    };
    PromiseResourcesApi.prototype.listResources = function (organizationId, beforeDate, limit, _options) {
        var result = this.api.listResources(organizationId, beforeDate, limit, _options);
        return result.toPromise();
    };
    return PromiseResourcesApi;
}());
exports.PromiseResourcesApi = PromiseResourcesApi;
var ObservableAPI_9 = require("./ObservableAPI");
var PromiseRolesApi = (function () {
    function PromiseRolesApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_9.ObservableRolesApi(configuration, requestFactory, responseProcessor);
    }
    PromiseRolesApi.prototype.addApiClientToRole = function (organizationId, roleId, apiClientId, _options) {
        var result = this.api.addApiClientToRole(organizationId, roleId, apiClientId, _options);
        return result.toPromise();
    };
    PromiseRolesApi.prototype.addUserToRole = function (organizationId, roleId, userId, _options) {
        var result = this.api.addUserToRole(organizationId, roleId, userId, _options);
        return result.toPromise();
    };
    PromiseRolesApi.prototype.createRole = function (organizationId, roleMutation, _options) {
        var result = this.api.createRole(organizationId, roleMutation, _options);
        return result.toPromise();
    };
    PromiseRolesApi.prototype.deleteRole = function (organizationId, roleId, _options) {
        var result = this.api.deleteRole(organizationId, roleId, _options);
        return result.toPromise();
    };
    PromiseRolesApi.prototype.getRole = function (organizationId, roleId, _options) {
        var result = this.api.getRole(organizationId, roleId, _options);
        return result.toPromise();
    };
    PromiseRolesApi.prototype.listApiClientsForRole = function (organizationId, roleId, _options) {
        var result = this.api.listApiClientsForRole(organizationId, roleId, _options);
        return result.toPromise();
    };
    PromiseRolesApi.prototype.listRoles = function (organizationId, _options) {
        var result = this.api.listRoles(organizationId, _options);
        return result.toPromise();
    };
    PromiseRolesApi.prototype.listUsersForRole = function (organizationId, roleId, _options) {
        var result = this.api.listUsersForRole(organizationId, roleId, _options);
        return result.toPromise();
    };
    PromiseRolesApi.prototype.removeApiClientFromRole = function (organizationId, roleId, apiClientId, _options) {
        var result = this.api.removeApiClientFromRole(organizationId, roleId, apiClientId, _options);
        return result.toPromise();
    };
    PromiseRolesApi.prototype.removeUserFromRole = function (organizationId, roleId, userId, _options) {
        var result = this.api.removeUserFromRole(organizationId, roleId, userId, _options);
        return result.toPromise();
    };
    PromiseRolesApi.prototype.updateRole = function (organizationId, roleId, roleMutation, _options) {
        var result = this.api.updateRole(organizationId, roleId, roleMutation, _options);
        return result.toPromise();
    };
    return PromiseRolesApi;
}());
exports.PromiseRolesApi = PromiseRolesApi;
var ObservableAPI_10 = require("./ObservableAPI");
var PromiseSettingsApi = (function () {
    function PromiseSettingsApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_10.ObservableSettingsApi(configuration, requestFactory, responseProcessor);
    }
    PromiseSettingsApi.prototype.getSettingsForOrganization = function (organizationId, _options) {
        var result = this.api.getSettingsForOrganization(organizationId, _options);
        return result.toPromise();
    };
    PromiseSettingsApi.prototype.updateSettingsForOrganization = function (organizationId, settingsMutation, _options) {
        var result = this.api.updateSettingsForOrganization(organizationId, settingsMutation, _options);
        return result.toPromise();
    };
    return PromiseSettingsApi;
}());
exports.PromiseSettingsApi = PromiseSettingsApi;
var ObservableAPI_11 = require("./ObservableAPI");
var PromiseTrailsApi = (function () {
    function PromiseTrailsApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_11.ObservableTrailsApi(configuration, requestFactory, responseProcessor);
    }
    PromiseTrailsApi.prototype.createTrail = function (organizationId, trailMutation, _options) {
        var result = this.api.createTrail(organizationId, trailMutation, _options);
        return result.toPromise();
    };
    PromiseTrailsApi.prototype.deleteTrail = function (organizationId, trailId, _options) {
        var result = this.api.deleteTrail(organizationId, trailId, _options);
        return result.toPromise();
    };
    PromiseTrailsApi.prototype.getTrail = function (organizationId, trailId, _options) {
        var result = this.api.getTrail(organizationId, trailId, _options);
        return result.toPromise();
    };
    PromiseTrailsApi.prototype.listTrails = function (organizationId, _options) {
        var result = this.api.listTrails(organizationId, _options);
        return result.toPromise();
    };
    PromiseTrailsApi.prototype.updateTrail = function (organizationId, trailId, trailMutation, _options) {
        var result = this.api.updateTrail(organizationId, trailId, trailMutation, _options);
        return result.toPromise();
    };
    return PromiseTrailsApi;
}());
exports.PromiseTrailsApi = PromiseTrailsApi;
var ObservableAPI_12 = require("./ObservableAPI");
var PromiseUsageAndBillingApi = (function () {
    function PromiseUsageAndBillingApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_12.ObservableUsageAndBillingApi(configuration, requestFactory, responseProcessor);
    }
    PromiseUsageAndBillingApi.prototype.createStripeSetupIntent = function (organizationId, _options) {
        var result = this.api.createStripeSetupIntent(organizationId, _options);
        return result.toPromise();
    };
    PromiseUsageAndBillingApi.prototype.deletePaymentMethod = function (organizationId, paymentMethodId, _options) {
        var result = this.api.deletePaymentMethod(organizationId, paymentMethodId, _options);
        return result.toPromise();
    };
    PromiseUsageAndBillingApi.prototype.getBilling = function (organizationId, _options) {
        var result = this.api.getBilling(organizationId, _options);
        return result.toPromise();
    };
    PromiseUsageAndBillingApi.prototype.listUsage = function (organizationId, _options) {
        var result = this.api.listUsage(organizationId, _options);
        return result.toPromise();
    };
    PromiseUsageAndBillingApi.prototype.updateBilling = function (organizationId, billingMutation, _options) {
        var result = this.api.updateBilling(organizationId, billingMutation, _options);
        return result.toPromise();
    };
    return PromiseUsageAndBillingApi;
}());
exports.PromiseUsageAndBillingApi = PromiseUsageAndBillingApi;
var ObservableAPI_13 = require("./ObservableAPI");
var PromiseUsersApi = (function () {
    function PromiseUsersApi(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_13.ObservableUsersApi(configuration, requestFactory, responseProcessor);
    }
    PromiseUsersApi.prototype.listRolesForUser = function (organizationId, userId, _options) {
        var result = this.api.listRolesForUser(organizationId, userId, _options);
        return result.toPromise();
    };
    PromiseUsersApi.prototype.listUsers = function (organizationId, _options) {
        var result = this.api.listUsers(organizationId, _options);
        return result.toPromise();
    };
    return PromiseUsersApi;
}());
exports.PromiseUsersApi = PromiseUsersApi;
//# sourceMappingURL=PromiseAPI.js.map